import React, { FunctionComponent, useState, useRef, useCallback } from 'react'
import Grid from '../Grid'
import useResizeObserver from '../../hooks/useResizeObserver/index.web'
import { DimensionsProviderProps } from '../../styles'
import { LayoutRectangleType } from './LayoutRectangleType'

// TODO: check values for x and y are correct
const DimensionsProvider: FunctionComponent<DimensionsProviderProps> = ({
    renderChildren,
    noExpand,
    testID,
}) => {
    const [dimensions, setDimensions] = useState<LayoutRectangleType>()
    const componentRef = useRef(null)

    const setNewDimensions = useCallback(
        /* istanbul ignore next */
        ({ width, height, right, top }) =>
            setDimensions({
                width,
                height,
                x: right,
                y: top,
            }),
        []
    )

    useResizeObserver(componentRef, setNewDimensions)

    return (
        <Grid noExpand={noExpand} data-testid={testID} ref={componentRef}>
            {renderChildren(dimensions)}
        </Grid>
    )
}

export default DimensionsProvider
